import { createContext, useContext, useState, useCallback } from "react";

const dict = {
    en: {
        nav: { menu: "Menu", reviews: "Reviews", gallery: "Gallery", about: "About", contact: "Contact" },
        cta: { order: "Order Now", call: "Call Now", checkout: "Checkout", add: "Add", view_cart: "View cart" },
        banner: "Fresh empanadas available now",
        hero: {
            kicker: "Dominican American Deli · New Haven",
            title_1: "La Esquina",
            title_2: "del Sabor",
            subtitle: "Authentic Latin food, pressed sandwiches, and home-style Dominican plates served fresh every day on Foxon Blvd.",
            badge_open: "Open now · until 8 PM",
        },
        menu: {
            title: "The Menu",
            subtitle: "Built from family recipes — priced to feed.",
            categories: { sandwiches: "Sandwiches", "club-sandwiches": "Club Sandwiches", grinders: "Grinders / Subs", wraps: "Wraps", salads: "Salads", fries: "Fries", mofongos: "Mofongos", "rice-and-beans": "Rice & Beans", "made-to-order": "Made to Order", empanadas: "Empanadas", juices: "Juices", dominican: "Dominican Plates", drinks: "Drinks" },
            empty: "Your cart is empty.",
        },
        cart: {
            title: "Your Order",
            pickup: "Pickup",
            delivery: "Delivery",
            delivery_paused: "Delivery paused — pickup only",
            subtotal: "Subtotal",
            delivery_fee: "Delivery fee",
            tax: "Sales Tax",
            tip: "Tip",
            total: "Total",
            name: "Full name",
            phone: "Phone",
            email: "Email (for receipt)",
            address: "Delivery address",
            notes: "Notes (optional)",
            checkout: "Pay & place order",
            empty: "Add something delicious to start.",
            free_pickup: "Free pickup",
        },
        reviews: { title: "Loved by New Haven", rating: "5.0 average rating" },
        gallery: { title: "From the kitchen", subtitle: "Follow @jandw_deli for daily specials." },
        about: {
            title: "Family-run since day one",
            body: "J & W Deli is a family-owned Dominican-American deli bringing the warmth, music, and big flavors of home to Foxon Blvd. From morning mangú to late-night chimis, we serve real food, the way abuela would.",
        },
        location: { title: "Find us", directions: "Get directions", hours: "Hours", today_peak: "Peak hours: 12 PM – 8 PM" },
        popup: {
            title: "Hungry? Get 10% off",
            body: "Drop your email and we'll send a coupon for your first online order.",
            placeholder: "you@example.com",
            cta: "Send my coupon",
            ok: "Coupon on the way! Check your inbox.",
        },
        success: { title: "¡Gracias! Order confirmed", body: "We're firing up the grill. You'll get a text when it's ready.", track: "Track my order" },
        admin: {
            login: "Admin login",
            email: "Email",
            password: "Password",
            sign_in: "Sign in",
            dashboard: "Dashboard",
            orders: "Orders",
            revenue: "Revenue",
            paid_orders: "Paid orders",
            pending: "Pending",
            preparing: "Preparing",
            delivered: "Delivered",
            subscribers: "Email subscribers",
            mark_preparing: "Preparing",
            mark_ready: "Ready",
            mark_delivered: "Delivered",
            no_orders: "No orders yet.",
            sign_out: "Sign out",
        },
    },
    es: {
        nav: { menu: "Menú", reviews: "Reseñas", gallery: "Galería", about: "Nosotros", contact: "Contacto" },
        cta: { order: "Ordenar", call: "Llamar", checkout: "Pagar", add: "Agregar", view_cart: "Ver carrito" },
        banner: "¡Empanadas recién hechas disponibles ahora!",
        hero: {
            kicker: "Deli Dominicano · New Haven",
            title_1: "La Esquina",
            title_2: "del Sabor",
            subtitle: "Comida latina auténtica, sándwiches prensados y platos dominicanos hechos con cariño todos los días en Foxon Blvd.",
            badge_open: "Abierto · hasta las 8 PM",
        },
        menu: {
            title: "El Menú",
            subtitle: "Recetas de familia — precio justo.",
            categories: { sandwiches: "Sándwiches", "club-sandwiches": "Club Sándwiches", grinders: "Grinders / Subs", wraps: "Wraps", salads: "Ensaladas", fries: "Papas Fritas", mofongos: "Mofongos", "rice-and-beans": "Arroz y Habichuela", "made-to-order": "Hecho al Momento", empanadas: "Empanadas", juices: "Jugos Naturales", dominican: "Platos Dominicanos", drinks: "Bebidas" },
            empty: "Tu carrito está vacío.",
        },
        cart: {
            title: "Tu Pedido",
            pickup: "Recoger",
            delivery: "Delivery",
            delivery_paused: "Delivery pausado — solo pickup",
            subtotal: "Subtotal",
            delivery_fee: "Envío",
            tax: "Impuesto",
            tip: "Propina",
            total: "Total",
            name: "Nombre completo",
            phone: "Teléfono",
            email: "Correo (para recibo)",
            address: "Dirección de entrega",
            notes: "Notas (opcional)",
            checkout: "Pagar y ordenar",
            empty: "Agrega algo delicioso para empezar.",
            free_pickup: "Recogida gratis",
        },
        reviews: { title: "Amado por New Haven", rating: "5.0 estrellas" },
        gallery: { title: "Desde la cocina", subtitle: "Síguenos @jandw_deli para los especiales del día." },
        about: {
            title: "Familiar desde el primer día",
            body: "J & W Deli es un deli dominicano-americano familiar que trae el calor, la música y los grandes sabores de casa a Foxon Blvd. Del mangú de la mañana al chimi de la noche, comida real, como la hace abuela.",
        },
        location: { title: "Visítanos", directions: "Cómo llegar", hours: "Horario", today_peak: "Pico: 12 PM – 8 PM" },
        popup: {
            title: "¿Hambre? 10% de descuento",
            body: "Déjanos tu correo y te enviamos un cupón para tu primer pedido online.",
            placeholder: "tu@correo.com",
            cta: "Enviar cupón",
            ok: "¡Cupón en camino! Revisa tu correo.",
        },
        success: { title: "¡Gracias! Pedido confirmado", body: "Ya estamos cocinando. Te avisaremos cuando esté listo.", track: "Ver mi pedido" },
        admin: {
            login: "Acceso admin",
            email: "Correo",
            password: "Contraseña",
            sign_in: "Entrar",
            dashboard: "Panel",
            orders: "Órdenes",
            revenue: "Ingresos",
            paid_orders: "Órdenes pagadas",
            pending: "Pendientes",
            preparing: "En preparación",
            delivered: "Entregadas",
            subscribers: "Suscriptores",
            mark_preparing: "Preparando",
            mark_ready: "Listo",
            mark_delivered: "Entregado",
            no_orders: "Sin órdenes aún.",
            sign_out: "Salir",
        },
    },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
    const [lang, setLang] = useState("en");
    const t = useCallback(
        (path) => {
            const parts = path.split(".");
            let cur = dict[lang];
            for (const p of parts) cur = cur?.[p];
            return cur ?? path;
        },
        [lang],
    );
    return (
        <I18nContext.Provider value={{ lang, setLang, t }}>
            {children}
        </I18nContext.Provider>
    );
}

export function useI18n() {
    const ctx = useContext(I18nContext);
    if (!ctx) throw new Error("useI18n must be used inside I18nProvider");
    return ctx;
}
